import { useTranslation } from 'react-i18next';
import { useCheckoutContext } from '@/context/CheckoutContext/CheckoutContext';
import styles from './SplitBillInfo.module.scss';

export const SplitBillInfo = () => {
  const { t } = useTranslation();
  const { state } = useCheckoutContext();

  if (state.splitType === 'SPLIT_BY_ITEMS') {
    return (
      <div className={styles.root}>
        <p>{t('checkout.splitBillInfo.splitByItems')}</p>
      </div>
    );
  }

  return state.numberOfSplits === 0 ? null : (
    <div className={styles.root}>
      <p>{t('checkout.splitBillInfo.splitByVar', { numberOfSplits: state.numberOfSplits })}</p>
    </div>
  );
};
